export default __webpack_public_path__ + "static/media/logo-white.739dd2eb.svg";